import axios from "axios";
import { API_ROOT } from "./Api-config";

const Instense = axios.create();
 

//if (window.location.href.indexOf("login") <= 0) {
Instense.defaults.baseURL = `${API_ROOT.backendHost}`;

const forceRedirectToLogin = () => {
  try {
    localStorage.clear();
  } catch (err) {
    // ignore localStorage clearing issues
  }
  try {
    sessionStorage.clear();
  } catch (err) {
    // ignore sessionStorage clearing issues
  }
  if (window.location.pathname !== "/login") {
    window.location.href = "/login";
  }
};

Instense.interceptors.request.use((config) => {
  if (localStorage.getItem("token") != null && localStorage.getItem("storage") != null) {
    config.headers.Authorization = `bearer ${localStorage.getItem("token")}`;
    let storage = JSON.parse(localStorage.getItem("storage")!);
    let userName = storage === null ? "" : (storage.userName as any);
    let tenantID = storage === null ? "" : (storage.tenantID as any);
    config.headers.Username = userName;
    config.headers.tenantId = tenantID;
  };
  return config;
}, (err) => {
  console.log(err);
  return Promise.reject(err);
});
 

Instense.interceptors.response.use((response) => {
  
  return response;
}, (error) => {
 
  if (error?.response?.data?.message === "under maintenance") {
    window.location.href = "/Under-Maintenance";
  }
  else if (error.response && error?.response?.data && error?.response?.data?.error &&
    (error.response.data.session === false || error.response.data.session === "false") || (localStorage.getItem("token") === null)) {
    alert(error.response.data.error.message);
    forceRedirectToLogin();
  }
  else if (error?.response && error?.response?.data && error?.response?.data?.error && error?.response?.data?.error?.message) {
    alert(error.response.data.error.message);
  }
  else
    if ((error?.response && error?.response?.status === 401) || (localStorage.getItem("token") === null)) {
      alert(error.response.data.error.message);
      forceRedirectToLogin();
    } else
      return Promise.reject(error);
});


export default Instense;
//export const AxiosRoot = `${Instense}`;

